import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck, FileText } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/ekrVXHXFRFrxfxMo6L8zyt/COVER_TDLO360.png', 'https://cdn.magicpatterns.com/uploads/hGmHJZYNVN7BXCJkLa8KGF/COVER_PO_360.png', 'https://cdn.magicpatterns.com/uploads/oAAzZJwGECcXeAjxiPbozd/UPSELL_TEORIA_DE_LAS_ORGANIZACIONES.png', 'https://cdn.magicpatterns.com/uploads/wQCJ71sq7gbMfLnWoCEaHg/ChatGPT_Image_11_ene_2026,_07_34_47_p.m..png'];
export function MegapackProyectosSection() {
  return <section className="py-12 px-4 bg-gradient-to-b from-blue-900 to-blue-800 text-white relative overflow-hidden" data-id="element-81">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-82"></div>

      {/* Premium Badge */}
      <div className="max-w-md mx-auto relative z-10 mb-8 text-center" data-id="element-83">
        <div className="inline-block bg-gradient-to-r from-green-500 to-teal-500 text-white px-6 py-2 rounded-full font-black text-lg uppercase tracking-wide shadow-xl" data-id="element-84">
          🎯 MEGAPACK PROYECTOS
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mt-4 mb-2" data-id="element-85">
          MEGAPACK PROYECTOS 360
        </h2>
        <p className="text-blue-200" data-id="element-86">
          Pack completo con proyectos integradores y casos reales para aplicar
          en el aula
        </p>
      </div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-87">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-green-500" data-id="element-88">
          {/* Carousel Section */}
          <div className="bg-gradient-to-b from-gray-50 to-white p-6" data-id="element-89">
            <ImageCarousel images={CAROUSEL_IMAGES} data-id="element-90" />
          </div>

          {/* Price Section */}
          <div className="px-6 py-8 text-center border-b border-gray-100" data-id="element-91">
            <p className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-92">
              Precio Final Pack Proyectos
            </p>
            <div className="mb-2" data-id="element-93">
              <span className="text-gray-400 text-2xl line-through" data-id="element-94">
                $99.990
              </span>
            </div>
            <div className="text-blue-900 font-black text-5xl mb-3" data-id="element-95">
              $49.990
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold" data-id="element-96">
              Ahorrás 50% HOY
            </div>
          </div>

          {/* Features Section */}
          <div className="px-6 py-6 space-y-4" data-id="element-97">
            {/* Feature 1 - Green */}
            <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex gap-3" data-id="element-98">
              <div className="flex-shrink-0 mt-1" data-id="element-99">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-100">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-101" />
                </div>
              </div>
              <div data-id="element-102">
                <h4 className="font-bold text-gray-900 mb-1 text-sm leading-tight" data-id="element-103">
                  Teoria de las organizaciones + Proyecto Organizacional + 100
                  MICRO-EMPRENDIMIENTOS GANADORES + Proyecto integrador Empresa
                  de Barrio
                </h4>
                <p className="text-sm text-gray-600" data-id="element-104">
                  El pack completo con proyectos integradores reales y casos
                  prácticos para tus alumnos
                </p>
              </div>
            </div>

            {/* Feature 2 - Teal */}
            <div className="bg-teal-50 border border-teal-200 rounded-xl p-4 flex gap-3" data-id="element-105">
              <div className="flex-shrink-0 mt-1" data-id="element-106">
                <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center" data-id="element-107">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-108" />
                </div>
              </div>
              <div data-id="element-109">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-110">
                  2 Bonos Exclusivos (Gratis por hoy)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-111">
                  Banco de actividades rápidas y pack completo de evaluaciones
                  listas
                </p>
              </div>
            </div>

            {/* Feature 3 - Blue */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3" data-id="element-112">
              <div className="flex-shrink-0 mt-1" data-id="element-113">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-114">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-115" />
                </div>
              </div>
              <div data-id="element-116">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-117">
                  Acceso Inmediato y Vitalicio
                </h4>
                <p className="text-sm text-gray-600" data-id="element-118">
                  Descargá todo el material al instante y accedé cuando lo
                  necesites, sin vencimiento
                </p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="px-6 pb-6" data-id="element-119">
            <Button href="https://checkout.rincondigital.shop/cart/52936956412179:1" variant="primary" size="lg" fullWidth withArrow className="shadow-xl shadow-green-500/30 text-lg py-5 bg-gradient-to-r from-green-500 to-teal-500 hover:from-green-600 hover:to-teal-600" data-id="element-120">
              ACCEDÉ AL MEGAPACK PROYECTOS 360
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="px-6 pb-6 flex items-center justify-center gap-6 text-sm text-gray-500" data-id="element-121">
            <div className="flex items-center gap-2" data-id="element-122">
              <ShieldCheck className="h-4 w-4 text-green-500" data-id="element-123" />
              <span data-id="element-124">Compra Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-125">
              <FileText className="h-4 w-4 text-blue-500" data-id="element-126" />
              <span data-id="element-127">Material Digital</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}